module.exports = __webpack_public_path__ + "templates/app.component.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 5xMp
// module chunks = 1